"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ChatBoxComponent = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = require("prop-types");
var _styledComponents = require("styled-components");
var _dsWeb = require("@olxbr/ds-web");
var _ChatList = _interopRequireDefault(require("../../ui/ChatList"));
var _ChatPlaceholderError = _interopRequireDefault(require("../../ui/ChatPlaceholderError"));
var _ChatPlaceholderNoInternetError = _interopRequireDefault(require("../../ui/ChatPlaceholderNoInternetError"));
var _ChatPlaceholderUserNotLogged = _interopRequireDefault(require("../../ui/ChatPlaceholderUserNotLogged"));
var _EmptyChatList = require("../../ui/EmptyChatList");
var _actions = require("../../../actions");
var _types = require("../../../actions/types");
var _selectors = require("../../../selectors");
var _style = require("./style");
var _platform = require("../../../helpers/platform");
var _ProzapHeader = _interopRequireDefault(require("../../ui/ProzapHeader"));
var _AdvertisingSlot = _interopRequireDefault(require("../../molecules/Advertising/AdvertisingSlot"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var IGNORE_CHANGE_ON_PROPS = ['changeCurrentChatAction', 'startWatchingPartnersAction', 'stopWatchingPartnersAction', 'startLoadChatsAction', 'redirectUserToLoginPageAction'];
var filterIgnoredProps = function filterIgnoredProps(key, value) {
  return IGNORE_CHANGE_ON_PROPS.includes(key) ? undefined : value;
};
var ChatBox = exports.ChatBoxComponent = /*#__PURE__*/function (_Component) {
  function ChatBox() {
    var _this;
    _classCallCheck(this, ChatBox);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ChatBox, [].concat(args));
    _defineProperty(_this, "start", function () {
      var startLoadChatsAction = _this.props.startLoadChatsAction;
      startLoadChatsAction();
    });
    _defineProperty(_this, "handleSelectChat", function (chat) {
      var _this$props = _this.props,
        changeCurrentChatAction = _this$props.changeCurrentChatAction,
        changeCurrentChatPositionAction = _this$props.changeCurrentChatPositionAction,
        chats = _this$props.chats;
      var position = chats.findIndex(function (item) {
        return item.roomname === chat.roomname;
      });
      var params = new URLSearchParams(window.location.search);
      params["delete"]('chat-id');
      var finalParams = "?chat-id=".concat(chat.roomname, "&").concat(params.toString());
      if (_platform.isMsite) {
        window.history.pushState(null, '', finalParams);
      } else {
        window.history.replaceState(null, '', finalParams);
      }
      changeCurrentChatAction(chat);
      changeCurrentChatPositionAction(position);
    });
    _defineProperty(_this, "renderChatPlaceholderError", function () {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPlaceholderError["default"], {
        onClick: _this.start
      });
    });
    _defineProperty(_this, "renderNoInternetError", function () {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPlaceholderNoInternetError["default"], {
        onClick: _this.start
      });
    });
    _defineProperty(_this, "renderChatList", function () {
      var _this$props2 = _this.props,
        renderToRight = _this$props2.renderToRight,
        chats = _this$props2.chats,
        uiState = _this$props2.uiState,
        alreadyLoaded = _this$props2.alreadyLoaded;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_react.Fragment, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatList["default"], {
          chats: chats,
          onPress: _this.handleSelectChat,
          loading: !alreadyLoaded && uiState === _types.UI.LOADING
        }), renderToRight && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ToRightComponentWrapper, {
          children: renderToRight()
        })]
      });
    });
    _defineProperty(_this, "renderUserNotLogged", function () {
      var redirectUserToLoginPageAction = _this.props.redirectUserToLoginPageAction;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_ChatPlaceholderUserNotLogged["default"], {
        onClick: redirectUserToLoginPageAction
      });
    });
    return _this;
  }
  _inherits(ChatBox, _Component);
  return _createClass(ChatBox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.start();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return JSON.stringify(this.props, filterIgnoredProps) !== JSON.stringify(nextProps, filterIgnoredProps);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props3 = this.props,
        arePartnersLoaded = _this$props3.arePartnersLoaded,
        startWatchingPartnersAction = _this$props3.startWatchingPartnersAction;
      if (prevProps.arePartnersLoaded !== arePartnersLoaded) {
        startWatchingPartnersAction();
      }
      this.handleChatsFilled();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var stopWatchingPartnersAction = this.props.stopWatchingPartnersAction;
      stopWatchingPartnersAction();
    }
  }, {
    key: "handleChatsFilled",
    value: function handleChatsFilled() {
      var result = window.location.search.includes('chat-id');
      if (result) {
        var url = window.location.href;
        var queryChatId = url.split('chat-id=');
        var paramChatId = queryChatId[1].split('==@conference.olxbr');
        var chatId = paramChatId[0] + '==@conference.olxbr';
        var _this$props4 = this.props,
          chats = _this$props4.chats,
          changeCurrentChatAction = _this$props4.changeCurrentChatAction;
        var chat = chats.find(function (chat) {
          return chat.roomname === chatId;
        });
        changeCurrentChatAction(chat);
      }
    }
  }, {
    key: "getRenderMethod",
    value: function getRenderMethod() {
      var _this$props5 = this.props,
        chats = _this$props5.chats,
        uiState = _this$props5.uiState;
      if (uiState === _types.UI.UNKNOWN_ERROR) return this.renderChatPlaceholderError;
      if (uiState === _types.UI.USER_NOT_LOGGED) return this.renderUserNotLogged;
      if (uiState === _types.UI.USER_NOT_IDENTIFIED) return this.renderUserNotLogged;
      if (uiState === _types.UI.NO_INTERNET) return this.renderNoInternetError;
      if (uiState !== _types.UI.LOADING && chats.length === 0) {
        return ChatBox.renderEmptyChatList;
      }
      return this.renderChatList;
    }
  }, {
    key: "render",
    value: function render() {
      var renderContent = this.getRenderMethod();
      var isOlx = this.props.isOlx;
      var showGads = !_platform.isMsite && isOlx;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_style.Wrapper, {
        children: [isOlx ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Header, {
          teamKey: "hQIPDF7Bfpw2WJUDwr9GV21jIoDSEJGl",
          hasNavbar: true
        }, new Date().getTime()) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_ProzapHeader["default"], {}), showGads && /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.PubArea, {
          justifyContent: "center",
          alignItems: "center",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_AdvertisingSlot["default"], {})
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.Main, {
          id: "main",
          className: "has-navbar",
          showGads: showGads,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.MainArea, {
            withMargin: !showGads,
            children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.ContentWrapper, {
              children: renderContent()
            })
          })
        })]
      });
    }
  }]);
}(_react.Component);
_defineProperty(ChatBox, "propTypes", {
  changeCurrentChatAction: _propTypes.func.isRequired,
  changeCurrentChatPositionAction: _propTypes.func.isRequired,
  startWatchingPartnersAction: _propTypes.func.isRequired,
  stopWatchingPartnersAction: _propTypes.func.isRequired,
  chats: _propTypes.array.isRequired,
  uiState: _propTypes.string.isRequired,
  startLoadChatsAction: _propTypes.func.isRequired,
  redirectUserToLoginPageAction: _propTypes.func.isRequired,
  renderToRight: _propTypes.func,
  alreadyLoaded: _propTypes.bool.isRequired,
  arePartnersLoaded: _propTypes.bool,
  isOlx: _propTypes.bool.isRequired
});
_defineProperty(ChatBox, "defaultProps", {
  renderToRight: null,
  arePartnersLoaded: false
});
_defineProperty(ChatBox, "renderEmptyChatList", function () {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_EmptyChatList.EmptyChatList, {});
});
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var ui = state.ui;
  var chat = ui.chat;
  var theme = ownProps.theme;
  return {
    chats: (0, _selectors.getOrderedChatsByLastMessage)(state),
    alreadyLoaded: (0, _selectors.alreadyLoadedChats)(state),
    arePartnersLoaded: (0, _selectors.arePartnersLoadedSelector)(state),
    uiState: chat,
    isOlx: theme.brand === 'olx'
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return (0, _actions.bindActionCreators)({
    changeCurrentChatAction: _actions.changeCurrentChat,
    changeCurrentChatPositionAction: _actions.changeCurrentChatPosition,
    startWatchingPartnersAction: _actions.startWatchingPartners,
    stopWatchingPartnersAction: _actions.stopWatchingPartners,
    startLoadChatsAction: _actions.startLoadChats,
    redirectUserToLoginPageAction: _actions.redirectUserToLoginPage
  }, dispatch);
};
var _default = exports["default"] = (0, _styledComponents.withTheme)((0, _actions.connect)(mapStateToProps, mapDispatchToProps)(ChatBox));